import { SvgIcon } from '@material-ui/core';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';

import { styles } from './Marker.styles';

export interface MarkerIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const MarkerIconComponent: React.FC<MarkerIconProps> = ({ classes, color = '#024795' }) => {
  return (
    <SvgIcon
      height="31"
      viewBox="0 0 23 31"
      width="23"
      xmlns="http://www.w3.org/2000/svg"
      classes={{ root: classes.root }}
    >
      <g fill="none" fillRule="evenodd">
        <ellipse cx="11.451613" cy="28.740409" fill="#192948" opacity=".153518" rx="7" ry="1.982097" />
        <path
          d="m11.5 0c-6.3503 0-11.5 5.04695438-11.5 11.2709573 0 6.3216118 5.03125 10.6428153 11.5 16.2892031 6.46875-5.6463878 11.5-9.9675913 11.5-16.2892031 0-6.22400292-5.1497-11.2709573-11.5-11.2709573z"
          fill={color}
          fillRule="nonzero"
        />
        <path
          d="m11.5 16.6509303c-2.93183654 0-5.30769231-2.3137616-5.30769231-5.1675301 0-2.85376851 2.37585577-5.1675301 5.30769231-5.1675301 2.9318365 0 5.3076923 2.31376159 5.3076923 5.1675301 0 2.8537685-2.3758558 5.1675301-5.3076923 5.1675301z"
          fill="#fff"
          fillRule="nonzero"
        />
      </g>
    </SvgIcon>
  );
};

export const MarkerIcon = withStyles(styles)(MarkerIconComponent);
